import { render, staticRenderFns } from "./entry_adult.vue?vue&type=template&id=5122906f&scoped=true&"
import script from "./entry_adult.vue?vue&type=script&lang=js&"
export * from "./entry_adult.vue?vue&type=script&lang=js&"
import style0 from "./entry_adult.vue?vue&type=style&index=0&id=5122906f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5122906f",
  null
  
)

export default component.exports